import React from 'react';

const IconMalta = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55.2 38.4" {...props}>
      <g fillRule="evenodd" clipRule="evenodd">
        <path
          fill="#fff"
          d="M3.03 0h49.13c1.67 0 3.03 1.36 3.03 3.03v32.33c0 1.66-1.36 3.02-3.02 3.03H3.02C1.36 38.4 0 37.03 0 35.37V3.03C0 1.36 1.36 0 3.03 0z"
        />
        <path
          fill="#cf142b"
          d="M27.6 0h24.57c1.67 0 3.03 1.36 3.03 3.03v32.33c0 1.66-1.36 3.02-3.02 3.03H27.6V0z"
        />
        <path
          fill="#c8a200"
          d="M5.5 3.5h5.5v1.2H8.8v5.5H7.6V4.7H5.5zm1.2 1.2h3.1v3.1H6.7zm.8.8h1.5v1.5H7.5z"
        />
      </g>
    </svg>
  );
};

export default IconMalta;
